import React from 'react';
import { FDBox } from '@facet-wealth/design';

const Financials = () => {
  return (
    <FDBox height={'100%'} width={'100%'}>
      {'Financials - Coming Soon'}
    </FDBox>
  );
};

Financials.defaultProps = {};

Financials.propTypes = {};

export { Financials };
